module.exports = {
id:136,
title: 'Details for Tomorrow’s Rally',
date: '2025-11-05',
content: `<p>I'm glad many of you are going to be joining us at the rally tomorrow. The address is:</p>
<p>LAUSD Local District NW<br/>
6621 Balboa Blvd<br/>
Van Nuys, CA 91406</p>
<h2>Parking</h2>
<p>The best place to park is on the west side of Balboa Blvd., south of Sherman Way, north of Vanowen. Parking will take a little time and you will probably need to walk several blocks. This is a good problem to have--we want a large crowd. The rally will be on Balboa, south of Vanowen.</p>
<h2>Where Monroe Will Meet at Rally</h2>
<p>Monroe&rsquo;s rallying point will be the North East corner/area of Balboa and Haynes, between Haynes and McLennan. If you can't find us, text or call me at (818) 470-8587.</p>
<h2>Rides</h2>
<p>We&rsquo;ve arranged rides for all who need them&ndash;if it turns out you need a ride, please let me know and we&rsquo;ll have one for you. The Monroe stadium lot is open very late--the transportation we provide will leave from there and return there.</p>
<p>If you have any problems before, during or after the rally, please don't hesitate to call or text me at (818) 470-8587.</p>`
}